/* ═══════════════════════════════════════════════════════════════════════════
   Practical Dreams · theme.js
   Mobile nav · AJAX cart drawer · toasts · scroll-reveal · smart header
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var PD = window.PD || {
    routes: { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js' },
    sectionId: 'cart-drawer'
  };
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ── Toasts ──────────────────────────────────────────────────────────── */
  function toast(msg, ok) {
    var wrap = $('#toastWrap');
    if (!wrap) return;
    var t = document.createElement('div');
    t.className = 'toast';
    t.innerHTML = (ok !== false
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>'
      : '') + '<span></span>';
    t.querySelector('span').textContent = msg;
    wrap.appendChild(t);
    setTimeout(function () { t.remove(); }, 2600);
  }
  window.pdToast = toast;

  /* ── Mobile nav ──────────────────────────────────────────────────────── */
  var ham = $('#hamBtn'), mobNav = $('#mob-nav'), scrim = $('#mob-scrim');

  function setMobNav(open) {
    if (!mobNav) return;
    mobNav.classList.toggle('open', open);
    mobNav.setAttribute('aria-hidden', String(!open));
    if (ham) {
      ham.classList.toggle('x', open);
      ham.setAttribute('aria-expanded', String(open));
      ham.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }
    if (scrim) {
      if (open) scrim.removeAttribute('hidden');
      else setTimeout(function () { scrim.setAttribute('hidden', ''); }, 220);
      scrim.classList.toggle('show', open);
    }
    lockScroll(open || drawerOpen);
    if (open) {
      var first = mobNav.querySelector('a');
      if (first) first.focus({ preventScroll: true });
    }
  }
  if (ham) ham.addEventListener('click', function () { setMobNav(!mobNav.classList.contains('open')); });
  if (scrim) scrim.addEventListener('click', function () { setMobNav(false); });
  if (mobNav) mobNav.addEventListener('click', function (e) {
    if (e.target.closest('a')) setMobNav(false);
  });
  // Close on resize up to desktop
  window.addEventListener('resize', function () {
    if (window.innerWidth > 840 && mobNav && mobNav.classList.contains('open')) setMobNav(false);
  });

  /* ── Body scroll lock ────────────────────────────────────────────────── */
  function lockScroll(lock) { document.body.style.overflow = lock ? 'hidden' : ''; }

  /* ── Cart drawer ─────────────────────────────────────────────────────── */
  var drawerOpen = false;
  var lastFocus = null;

  function drawer() { return $('#cartDrawer'); }
  function overlay() { return $('#cartOverlay'); }

  function openDrawer() {
    var d = drawer(), o = overlay();
    if (!d) { window.location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    drawerOpen = true;
    if (o) { o.removeAttribute('hidden'); requestAnimationFrame(function () { o.classList.add('open'); }); }
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    d.focus({ preventScroll: true });
  }

  function closeDrawer() {
    var d = drawer(), o = overlay();
    if (!d) return;
    drawerOpen = false;
    d.classList.remove('open');
    d.setAttribute('aria-hidden', 'true');
    if (o) {
      o.classList.remove('open');
      setTimeout(function () { o.setAttribute('hidden', ''); }, 220);
    }
    lockScroll(mobNav && mobNav.classList.contains('open'));
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  // Focus trap inside drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawerOpen) closeDrawer();
      else setMobNav(false);
      return;
    }
    if (e.key !== 'Tab' || !drawerOpen) return;
    var d = drawer();
    var focusables = $$('a[href], button:not([disabled]), [tabindex="0"]', d);
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  });

  // Delegated clicks: open / close / qty controls
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }

    var closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) { if (closeBtn.tagName !== 'A') e.preventDefault(); closeDrawer(); return; }

    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      var row = qtyBtn.closest('[data-line-key]');
      if (row) changeLine(row.dataset.lineKey, parseInt(qtyBtn.dataset.cartQty, 10), row);
    }
  });

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=' + PD.sectionId, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[PD.sectionId];
        if (!html) return;
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var freshDrawer = holder.querySelector('#cartDrawer');
        var cur = drawer();
        if (freshDrawer && cur) {
          // Preserve open state
          freshDrawer.classList.toggle('open', drawerOpen);
          freshDrawer.setAttribute('aria-hidden', String(!drawerOpen));
          cur.replaceWith(freshDrawer);
        }
        syncCountFromDrawer();
      });
  }

  function syncCountFromDrawer() {
    var el = $('[data-cart-drawer-count]');
    var n = el ? parseInt(el.textContent, 10) || 0 : 0;
    $$('[data-cart-count]').forEach(function (c) {
      c.textContent = n;
      c.classList.toggle('show', n > 0);
      c.classList.remove('pulse'); void c.offsetWidth; c.classList.add('pulse');
    });
  }

  function changeLine(key, qty, row) {
    if (row) row.classList.add('busy');
    fetch(PD.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { return refreshDrawer(); })
      .catch(function () { toast('Could not update cart', false); if (row) row.classList.remove('busy'); });
  }

  /* ── Cart note (order-level special requests) ───────────────────────── */
  var noteTimer = null;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    var field = e.target;
    var status = field.parentElement.querySelector('[data-cart-note-status]');
    if (status) status.textContent = 'Saving…';
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(PD.routes.cartUpdate || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: field.value })
      })
        .then(function (r) { if (!r.ok) throw new Error(); })
        .then(function () { if (status) status.textContent = 'Saved, added to your order'; })
        .catch(function () { if (status) status.textContent = 'Could not save, try again'; });
    }, 600);
  });

  /* ── AJAX add to cart ────────────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
    // Let dynamic checkout buttons (Buy it now, Shop Pay, GPay, PayPal) submit normally
    if (e.submitter && e.submitter.name && e.submitter.name !== 'add') return;
    e.preventDefault();

    // Respect required personalisation fields: trigger native validation + focus
    // the first invalid field so the customer sees what's missing before adding.
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      var firstInvalid = form.querySelector(':invalid');
      if (firstInvalid) {
        firstInvalid.focus();
        firstInvalid.classList.add('field-invalid');
        firstInvalid.addEventListener('input', function clear() {
          firstInvalid.classList.remove('field-invalid');
          firstInvalid.removeEventListener('input', clear);
        });
      }
      toast('Please complete the highlighted field', false);
      return;
    }

    var btn = form.querySelector('[name="add"], [type="submit"]');
    var btnHTML = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.innerHTML = '<span class="spin" aria-hidden="true"></span> Adding…'; }

    fetch(PD.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && res.j.description || 'Could not add to cart');
        return refreshDrawer().then(function () {
          toast('Added to cart');
          openDrawer();
        });
      })
      .catch(function (err) { toast(err.message || 'Could not add to cart', false); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = btnHTML; } });
  });

  /* ── Scroll reveal ───────────────────────────────────────────────────── */
  var revealEls = $$('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window && !reducedMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ── Header: always visible — cart lives in the nav ──────────────────── */
  var headerSection = document.getElementById('shopify-section-header') || $('.site-header');
  var collToolbar = $('.coll-toolbar');
  var lastY = window.scrollY, ticking = false;
  function applyScrolled(y){
    document.body.classList.toggle('pd-scrolled', y > 60);
  }
  function updateDock(){
    if (!collToolbar) return;
    var hb = headerSection ? Math.max(0, headerSection.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--dock-top', hb + 'px');
    collToolbar.classList.toggle('is-docked', collToolbar.getBoundingClientRect().top <= hb + 1);
  }
  applyScrolled(window.scrollY);
  updateDock();
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      applyScrolled(y);
      if (collToolbar) updateDock();
      lastY = y;
      ticking = false;
    });
  }, { passive: true });
  window.addEventListener('resize', updateDock, { passive: true });

  /* ── Sticky mobile add-to-cart (product pages) ───────────────────────── */
  var atcZone = $('.atc-zone');
  var pdpBody = $('.pdp-body');
  if (atcZone && pdpBody && 'IntersectionObserver' in window) {
    var bar = document.createElement('div');
    bar.className = 'sticky-atc';
    var title = $('.pdp-title');
    var price = $('.price');
    bar.innerHTML =
      '<div class="sticky-atc-info">' +
        '<strong>' + (title ? title.textContent.trim() : '') + '</strong>' +
        '<span>' + (price ? price.textContent.trim() : '') + '</span>' +
      '</div>' +
      '<button type="button" class="btn btn-grad btn-sm" id="sticky-atc-btn">Add to cart</button>';
    document.body.appendChild(bar);
    bar.querySelector('#sticky-atc-btn').addEventListener('click', function () {
      /* Click the real ATC button so the AJAX handler fires — never call
         form.submit() directly as that bypasses the handler and causes a
         redirect to the collection page */
      var realBtn = document.querySelector('form[data-type="add-to-cart-form"] button[name="add"]');
      if (realBtn) realBtn.click();
    });
    var atcIO = new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('show', show);
      document.body.classList.toggle('has-sticky-atc', show);
    }, { threshold: 0 });
    atcIO.observe(atcZone);
  }

  /* ── Rotating announcement bar ───────────────────────────────────────── */
  var annRotator = $('.ann-rotator');
  if (annRotator) {
    var annMsgs = $$('.ann-msg', annRotator);
    if (annMsgs.length > 1) {
      var annInterval = parseInt(annRotator.dataset.interval, 10) || 5000;
      if (reducedMotion) annInterval = Math.max(annInterval, 6000);
      var annIdx = 0;
      setInterval(function () {
        var current = annMsgs[annIdx];
        var nextIdx = (annIdx + 1) % annMsgs.length;
        var next = annMsgs[nextIdx];
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        next.classList.add('is-active');
        setTimeout(function () { current.classList.remove('is-leaving'); }, 400);
        annIdx = nextIdx;
      }, annInterval);
    }
  }

  /* ── Search overlay + predictive search ──────────────────────────────── */
  var searchBtn = $('#searchBtn');
  var searchOverlay = $('#searchOverlay');
  var searchClose = $('#searchClose');
  var searchInput = $('#searchInput');
  var searchResults = $('#searchResults');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.hidden = false;
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { searchInput && searchInput.focus(); }, 50);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.hidden = true;
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
    if (searchResults) searchResults.innerHTML = '';
  }
  if (searchBtn) searchBtn.addEventListener('click', function () {
    searchOverlay.hidden ? openSearch() : closeSearch();
  });
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay && !searchOverlay.hidden) closeSearch();
  });

  if (searchInput && searchResults) {
    var searchTimer = null;
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchResults.innerHTML = '<p class="search-loading">Searching…</p>';
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,tag')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p class="search-empty">' + ('No results for "' + q + '". Try "earth lamp" or "ganesha".') + '</p>';
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              var img = p.featured_image ? p.featured_image.url : (p.image || '');
              return '<a class="search-result" href="' + p.url + '">' +
                (img ? '<img src="' + img + '&width=104" alt="" loading="lazy">' : '') +
                '<span class="search-result-body">' +
                  '<span class="search-result-title">' + p.title + '</span>' +
                  '<span class="search-result-price">' + (p.price || '') + '</span>' +
                '</span>' +
              '</a>';
            }).join('');
          })
          .catch(function () { searchResults.innerHTML = ''; });
      }, 220);
    });
  }

  /* ── Related products: fetch Shopify's recommendations and swap in ──── */
  $$('[data-recommendations]').forEach(function (section) {
    var url = section.dataset.url;
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-recommendations-grid]');
        var currentGrid = section.querySelector('[data-recommendations-grid]');
        if (newGrid && currentGrid && newGrid.children.length) {
          currentGrid.innerHTML = newGrid.innerHTML;
          revealEls = $$('[data-reveal]', currentGrid);
          if ('IntersectionObserver' in window) {
            var io2 = new IntersectionObserver(function (entries) {
              entries.forEach(function (en) {
                if (en.isIntersecting) { en.target.classList.add('in'); io2.unobserve(en.target); }
              });
            }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
            revealEls.forEach(function (el) { io2.observe(el); });
          } else {
            revealEls.forEach(function (el) { el.classList.add('in'); });
          }
        }
      })
      .catch(function () { /* keep the fallback grid already rendered */ });
  });
})();

/* ── STICKY MOBILE ATC BAR — handled by theme.js .sticky-atc ─────────────── */
// The sticky bar is built and managed by the JS in theme.js (class: sticky-atc).
// The duplicate pdp-sticky-atc Liquid element has been removed.

/* ── SWIPE GALLERY (PDP image gallery) ──────────────────────────────────── */
(function(){
  var mainWrap = document.getElementById('main-img-wrap');
  var mainImg  = document.getElementById('pdp-main-img');
  if (!mainWrap || !mainImg) return;
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pdp-thumb'));
  if (thumbs.length < 2) return;
  var current = 0;
  function goTo(idx) {
    idx = ((idx % thumbs.length) + thumbs.length) % thumbs.length;
    current = idx;
    /* read the pre-built full-size URL from data-full — no URL manipulation */
    var src = thumbs[idx].dataset.full || thumbs[idx].querySelector('img').src;
    mainImg.style.opacity = '0';
    setTimeout(function(){
      mainImg.src = src;
      mainImg.style.opacity = '1';
      thumbs.forEach(function(t,i){ t.classList.toggle('active', i === idx); });
    }, 120);
  }
  mainImg.style.transition = 'opacity .18s ease';
  var x0 = null, y0 = null;
  mainWrap.addEventListener('touchstart', function(e){
    x0 = e.touches[0].clientX;
    y0 = e.touches[0].clientY;
  }, { passive: true });
  mainWrap.addEventListener('touchend', function(e){
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    var dy = e.changedTouches[0].clientY - y0;
    /* only trigger for horizontal swipes (not page scroll) */
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
      goTo(current + (dx < 0 ? 1 : -1));
    }
    x0 = null; y0 = null;
  }, { passive: true });
})();
